/**
 * feature-config flag names owned by trust-and-safety
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const TRUST_AND_SAFETY_FLAG_NAMES = {
  // Gates SUPPRESSING a form notification email at send time on
  // phishing-content detection. Separate from save-time blocking and from
  // FORM_EMAIL_TEMPLATE_VALIDATION (detection/logging only) so suppression can
  // ramp/revert independently. See validateFormTemplateContentAtSendTime.ts.
  FORM_EMAIL_TEMPLATE_VALIDATION_SEND_TIME_BLOCKING:
    'ff-tns-283-form-email-template-validation-send-time-blocking',
  PORT_CST_AUTOMATIONS_TO_ADMIN: 'ff-tns-245-port-cst-automations-to-admin',
  // Kill-switch for enforcing an emailDestinations size cap on paid
  // (non-free) sites, at both write time (validateEmailDestinationCount)
  // and send time (formData.ts). Paid sites previously had no cap at all.
  PAID_SITE_EMAIL_DESTINATION_LIMIT:
    'ff-tns-281-paid-site-email-destination-limit',
  // Gates actually BLOCKING a form save on phishing-content detection,
  // decoupled from FORM_EMAIL_TEMPLATE_VALIDATION (which only gates
  // detection/logging) so blocking can ramp/revert independently. See
  // validateFormTemplateContent.ts for the reasoning.
  FORM_EMAIL_TEMPLATE_VALIDATION_BLOCKING:
    'ff-tns-282-form-email-template-validation-blocking',
  // Gates sending SAFER-flagged assets to the review service input queue (and
  // marking them flagged). See processSaferPertinentOutput.ts.
  SAFER_REVIEW_ROUTING: 'ff-tns-356-enable-safer-review-routing',
  // Runtime toggle for the Okta admin session check in restrictAdmin.
  OKTA_ADMIN_SESSION: 'ff-tns-330-okta-admin-session',
};

export const TRUST_AND_SAFETY_DYNAMIC_CONFIG_NAMES = {
  FORM_RECIPIENT_SETTINGS_RATE_LIMIT:
    'dc-tns-281-form-recipient-settings-rate-limit',
  // Per-site outbound budget on form notification email (TNS-318, INC-1423).
  // Mode off/shadow/enforce plus per-window allowances. See
  // formEmailSiteBudget.ts.
  FORM_EMAIL_SITE_BUDGET: 'dc-tns-318-form-email-site-budget',
} as const;
